import {toast, ToastTypes} from "../components/toasts/toast/toast";

let port = null; // Variable global para mantener la referencia al puerto abierto.
  let reader = null; // Variable global para el lector del puerto.

  const handleConnect = async (antennaCount, mode, setForm, setDistance) => {
    try {
      port = await navigator.serial.requestPort();
      console.log('Dispositivo seleccionado:', port);
      await port.open({ baudRate: 115200 });
      console.log('Puerto abierto con éxito');
      // Obtén el lector del puerto
      reader = port.readable.getReader();
      const response = await handleSendMessage(null, setForm, antennaCount, mode, setDistance);
    } catch (error) {
      console.error('Error al seleccionar el dispositivo o abrir el puerto:', error);
    }
  };

  const setupPrints = () => {
      navigator.serial.addEventListener('connect', (event) => {
          console.log('Dispositivo serial conectado:', event.target);
      });
      navigator.serial.addEventListener('disconnect', (event) => {
          console.log('Dispositivo serial desconectado:', event.target);
      });
  }

  const handleSendMessage = async (form, setForm, antennaCount, mode, setDistance) => {
    if (port && reader) {
      try {
        let message = ""
        if(!form) {
          console.log("sending start message...");
          message = "3, 0";
        } else {
          if(form["mode"] === "0,") {
            message = form["mode"];
            message += form["offset_1"] + "," + form["height_1"];
            if (form['antennas'] === '2 Antenna') {
              message += "," + form["offset_2"] + "," + form["height_2"];
            }
          } else if(form["antenna"] === "Antenna 1") {
            message = "1,";
            message += form["distance"];
          } else if(form["antenna"] === "Antenna 2") {
            message = "2,";
            message += form["distance"];
          }
        }

        console.log(message);

        const textEncoder = new TextEncoder();
        const data = textEncoder.encode(message);

        const writer = port.writable.getWriter();
        await writer.write(data);
        writer.releaseLock();
        toast("Configuración enviada", ToastTypes.SUCCESS);

        // Escuchar la respuesta del dispositivo.
        while (true) {
          const { value, done } = await reader.read();
          if (done) {
            console.log('La respuesta ha sido completamente recibida.');
            break;
          }
          // `value` es un Uint8Array, puedes convertirlo a texto si es necesario.
          const textDecoder = new TextDecoder();
          const textValue = textDecoder.decode(value);
          //console.log('Respuesta del dispositivo:', textValue);
          if(textValue[0] === "D") {
            const rangeMatch = textValue.match(/([-+]?\d*.\d+) m.*?Sampling: ([-+]?\d*.\d+) Hz/);

            if (rangeMatch && rangeMatch[2]) {
              const rangeValue = parseFloat(rangeMatch[1]);// * parseFloat(rangeMatch[2]);
              const hzValue = parseFloat(rangeMatch[2]);

              setDistance(rangeValue);
              //console.log("Range:", rangeValue);
            }
          }
          else if(textValue[0] === "L") {
            const retrievedValues = textValue.split(':')[1];
            const val1 = parseInt(retrievedValues.split(',')[1])
            const val2 = parseInt(retrievedValues.split(',')[2])
            const val3 = parseInt(retrievedValues.split(',')[3])
            const val4 = parseInt(retrievedValues.split(',')[4])
            if(val1) {
              setForm({
                antennas: antennaCount,
                mode: mode,
                offset_1: val1,
                height_1: val2,
                offset_2: val3,
                height_2: val4,
              });
            }
          }
        }
      } catch (error) {
        console.log(error);
        toast("Dispositivo desconectado", ToastTypes.ERROR);
      }
    } else {
      toast("Por favor, selecciona un dispositivo", ToastTypes.WARNING)
    }
  };

  export {
      handleConnect,
      handleSendMessage,
      setupPrints
  }
